<template>
  <div class="catalogue-container">
    <!-- Barre de recherche -->

    <SearchBar v-model="searchQuery" :products="productList" />

    <!-- Liste des catégories -->
    <h3 class="title">
      {{ $t("categories") }}
    </h3>
    <div class="category-wrapper" v-if="categoryList.length > 0">
      <button class="scroll-btn left" @click="scrollLeft">‹</button>

      <div class="category-list" ref="categoryListRef">
        <button
          v-for="(category, index) in categoryList"
          :key="index"
          class="category-item"
          :class="{
            'active-cat':
              selectedCategory && selectedCategory.id === category.id,
          }"
          @click="selectCategory(category)"
        >
          <img
            :src="category.image"
            :alt="category.name"
            width="60"
            height="60"
            loading="lazy"
          />
          <p>{{ category.name }}</p>
        </button>
      </div>

      <button class="scroll-btn right" @click="scrollRight">›</button>
    </div>
  </div>

  <div
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-inline: 15px;
    "
  >
    <h1 class="title-shop">
      {{ $t("shop") }}
    </h1>

    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: whitesmoke;
        border-radius: 8px;
        padding: 5px;
        cursor: pointer;
      "
      @click="goToCatalog"
    >
      {{ $t("catalogue") }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        color="#000000"
        fill="none"
      >
        <path
          d="M3.88884 9.66294C4.39329 10 5.09552 10 6.49998 10C7.90445 10 8.60668 10 9.11113 9.66294C9.32951 9.51702 9.51701 9.32952 9.66292 9.11114C9.99998 8.60669 9.99998 7.90446 9.99998 6.5C9.99998 5.09554 9.99998 4.39331 9.66292 3.88886C9.51701 3.67048 9.32951 3.48298 9.11113 3.33706C8.60668 3 7.90445 3 6.49998 3C5.09552 3 4.39329 3 3.88884 3.33706C3.67046 3.48298 3.48296 3.67048 3.33705 3.88886C2.99998 4.39331 2.99998 5.09554 2.99998 6.5C2.99998 7.90446 2.99998 8.60669 3.33705 9.11114C3.48296 9.32952 3.67046 9.51702 3.88884 9.66294Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M14.8888 9.66294C15.3933 10 16.0955 10 17.5 10C18.9044 10 19.6067 10 20.1111 9.66294C20.3295 9.51702 20.517 9.32952 20.6629 9.11114C21 8.60669 21 7.90446 21 6.5C21 5.09554 21 4.39331 20.6629 3.88886C20.517 3.67048 20.3295 3.48298 20.1111 3.33706C19.6067 3 18.9044 3 17.5 3C16.0955 3 15.3933 3 14.8888 3.33706C14.6705 3.48298 14.483 3.67048 14.337 3.88886C14 4.39331 14 5.09554 14 6.5C14 7.90446 14 8.60669 14.337 9.11114C14.483 9.32952 14.6705 9.51702 14.8888 9.66294Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M3.88884 20.6629C4.39329 21 5.09552 21 6.49998 21C7.90445 21 8.60668 21 9.11113 20.6629C9.32951 20.517 9.51701 20.3295 9.66292 20.1111C9.99998 19.6067 9.99998 18.9045 9.99998 17.5C9.99998 16.0955 9.99998 15.3933 9.66292 14.8889C9.51701 14.6705 9.32951 14.483 9.11113 14.3371C8.60668 14 7.90445 14 6.49998 14C5.09552 14 4.39329 14 3.88884 14.3371C3.67046 14.483 3.48296 14.6705 3.33705 14.8889C2.99998 15.3933 2.99998 16.0955 2.99998 17.5C2.99998 18.9045 2.99998 19.6067 3.33705 20.1111C3.48296 20.3295 3.67046 20.517 3.88884 20.6629Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M14.8888 20.6629C15.3933 21 16.0955 21 17.5 21C18.9044 21 19.6067 21 20.1111 20.6629C20.3295 20.517 20.517 20.3295 20.6629 20.1111C21 19.6067 21 18.9045 21 17.5C21 16.0955 21 15.3933 20.6629 14.8889C20.517 14.6705 20.3295 14.483 20.1111 14.3371C19.6067 14 18.9044 14 17.5 14C16.0955 14 15.3933 14 14.8888 14.3371C14.6705 14.483 14.483 14.6705 14.337 14.8889C14 15.3933 14 16.0955 14 17.5C14 18.9045 14 19.6067 14.337 20.1111C14.483 20.3295 14.6705 20.517 14.8888 20.6629Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  <Catalogue :modelValue="filteredProducts" />
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { fetchApi } from "../utils/api";
import SearchBar from "../components/SearchBar.vue";
import Catalogue from "../components/CatalogueList.vue";
import { useRouter } from "vue-router";
import { STORE_ID } from "../config";

const productList = ref([]);
const categoryList = ref([]);
const selectedCategory = ref(null);
const searchQuery = ref("");
const loading = ref(true);
const baseURL = "https://gestionshoop.shooplinkdz.com";
const router = useRouter();

// Produits filtrés selon la recherche et la catégorie
const filteredProducts = computed(() => {
  return productList.value.filter((product) => {
    const matchSearch =
      !searchQuery.value ||
      product.name.toLowerCase().includes(searchQuery.value.toLowerCase());
    const isActive = product.prodActive == 1;

    let matchCategory = true;
    if (selectedCategory.value) {
      matchCategory = product.category == selectedCategory.value.id;
    }

    // Store Filter
    let matchStore = false;
    try {
      if (product.stores_active) {
        let stores = product.stores_active;
        if (typeof stores === "string") {
          try {
            stores = JSON.parse(stores);
          } catch (e) {
            // If parsing fails but it's a string, maybe it's a CSV or single ID?
            // Assuming JSON array based on context. If fail, treat as empty.
            stores = [];
          }
        }
        if (Array.isArray(stores)) {
          if (
            stores.includes(STORE_ID) ||
            stores.includes(String(STORE_ID)) ||
            stores.includes(Number(STORE_ID))
          ) {
            matchStore = true;
          }
        }
      }
    } catch (e) {
      console.error("Error checking stores_active", e);
    }

    return matchSearch && isActive && matchCategory && matchStore;
  });
});

const selectCategory = (category) => {
  if (selectedCategory.value && selectedCategory.value.id === category.id) {
    selectedCategory.value = null; // Deselect if already selected
  } else {
    selectedCategory.value = category;
  }
};

const goToCatalog = () => {
  router.push(`/produits`);
};

// Récupération des produits depuis l’API
/*const postTestEmail = async () => {
  const response = await fetchApi(
    `${baseURL}/backend/api.php?token=test&action=sendTestEmail`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ orderID: 13 }),
    }
  );

  const result = await response.json();
  console.log("result:", result);
};*/
const getProducts = async () => {
  try {
    loading.value = true;
    const response = await fetchApi(
      `${baseURL}/backend/api.php?token=test&action=getProducts`
    );

    if (!response.ok) {
      console.error(
        "Erreur lors de la récupération des produits:",
        response.statusText
      );
      return;
    }

    const result = await response.json();
    // Normalize data: map imageUrls to image if necessary
    if (result.data) {
      productList.value = result.data.map((product) => {
        if (!product.image && product.imageUrls) {
          product.image = product.imageUrls;
        }
        return product;
      });
    } else {
      productList.value = [];
    }
  } catch (error) {
    console.error("Une erreur est survenue:", error);
  } finally {
    loading.value = false;
  }
};

// Récupération des catégories depuis l’API
const getCategory = async () => {
  try {
    const response = await fetchApi(
      `${baseURL}/backend/api.php?token=test&action=getCategory`
    );

    if (!response.ok) {
      console.error(
        "Erreur lors de la récupération des catégories:",
        response.statusText
      );
      return;
    }

    const result = await response.json();
    categoryList.value = result.categories;
  } catch (error) {
    console.error("Une erreur est survenue:", error);
  }
};

const categoryListRef = ref(null);

const scrollAmount = 200;

const scrollLeft = () => {
  categoryListRef.value.scrollBy({
    left: -scrollAmount,
    behavior: "smooth",
  });
};

const scrollRight = () => {
  categoryListRef.value.scrollBy({
    left: scrollAmount,
    behavior: "smooth",
  });
};

let isDown = false;
let startX;
let scrollLeftStart;

onMounted(() => {
  //postTestEmail();
  getProducts();
  getCategory();
  const slider = categoryListRef.value;

  if (!slider) return; // 🔥 évite le crash

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeftStart = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeftStart - walk;
  });
});
</script>

<style scoped>
.catalogue-container {
  width: 100%;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-shop {
  font-size: 1.5rem; /* Reduced size for elegance */
  font-weight: 600;
  color: var(--dark);
  text-align: center;
  margin-bottom: 1rem;
}

.title {
  font-size: 1.2rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  color: var(--gray);
}

/* Styles for Category List */
.category-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 15px;
  padding: 10px 5px;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  margin-block: 20px;
  scrollbar-width: none; /* Hide scrollbar Firefox */
  -ms-overflow-style: none; /* Hide scrollbar IE */
}

.category-list::-webkit-scrollbar {
  display: none; /* Hide scrollbar Chrome/Safari */
}

.category-item {
  flex: 0 0 auto;
  scroll-snap-align: start;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 80px; /* Slightly smaller */
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
}

.category-item.active-cat p {
  color: var(--dark);
  font-weight: 700;
}

.category-item.active-cat img {
  border-color: var(--secondary);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.category-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--border, #e5e7eb);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
  background-color: white;
  padding: 5px;
}

.category-item:hover img {
  border-color: var(--secondary);
}

.category-item p {
  font-weight: 500;
  text-align: center;
  width: 100%;
  margin-top: 8px;
  font-size: 0.8rem;
  color: var(--dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s;
}

.category-item:hover p {
  color: var(--dark);
}

.category-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* Boutons scroll */
.scroll-btn {
  position: absolute;
  z-index: 2;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.2s;
}

.scroll-btn:hover {
  transform: scale(1.1);
}

.scroll-btn.left {
  left: 0;
}

.scroll-btn.right {
  right: 0;
}

/* Ajouter padding pour éviter overlap */
.category-list {
  padding-inline: 40px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* mobile smooth */
}
</style>
